
import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

import {List, ListItem} from 'material-ui/List'

import { doc } from 'selectors/common'

import PropertyStatusIcon from './StatusIcon'

const colors = {
	forRent: "#BA68C8",
	outOfServ: "#000",
	occupied: "#39cea8",
	retired: "#A0A0A0"
}

let select = (state, props) => ({
	property: doc(state, props.id)
})

export class PropertyCard extends Component{
	render(){
		return(
			(!this.props.property)? <div></div>
			:<Link
				className="ent-card property-card"
				to={`/manager/properties/${this.props.id}`}
				style={{
					textDecoration: 'none'
				  , ...this.props.style
				}}
				key={this.props.key}
			>
				<ListItem
					key={`property-${this.props.id}`}
					style={{
						height: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))? "96px" : "86px"
					  , backgroundColor: (this.props.id == this.props.detailID)?"rgba(140, 222, 232, 0.298039)":"#FFF"
					  , overflow: 'hidden'
					  , paddingLeft: (typeof global.md.phone() == 'string')?"10px":"0"
					  , marginLeft: (typeof global.md.phone() != 'string')?"0":undefined
					  , borderBottom: "1px solid #e1e3e2"
					  , margin: "0"
					  , textOverflow: "ellipsis"
					}}
					className="list-hover"
				>
					<PropertyStatusIcon id={this.props.id} />
					<div style={{marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"12px":"8px"}}>
						<p
							className="main-text"
							style={{
								position: "relative"
							  , maxWidth: "50%"
							  , fontSize: "16px"
							  , fontWeight: "bold"
							  , marginTop: "2px"
							  , marginLeft: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"30px":"0px"
							  , marginBottom: "0px"
							  , textOverflow: "ellipsis"
							  , whiteSpace: "nowrap"
							  , overflow: "hidden"
							}}
						>
							{(this.props.property.alias != "")? this.props.property.alias : "No property alias"}
						</p>
					</div>
					<div style={{fontSize: "14px", height: "18px", marginTop: (typeof global.md.phone() == "string" || (typeof global.md.tablet() == 'string' && window.innerWidth < window.innerHeight))?"40px":"0px"}}>
						<p style={{overflow: "hidden", maxWidth: "calc(100% - 16px)", textOverflow: "ellipsis", marginTop: "8px", height: "18px"}}>{(this.props.property.address != "")? this.props.property.address : "No property address"}</p>
					</div>
					<div
						style={{
							float: "right"
						  , top: "-42px"
						  , position: "relative"
						  , left: "-20px"
						  , color:
								(this.props.property.status=='For Rent')?colors.forRent:
									(this.props.property.status=='Occupied')?colors.occupied:
									(this.props.property.status=='Retired')?colors.retired:
									(this.props.property.status=='Out Of Service'|| this.props.property.status=='Not in Service')?colors.outOfServ: "#A0A0A0"
						  , fontSize: "14px"
						  , fontWeight: "bold"
						  , textOverflow: "ellipsis"
						}}
					>
						{(this.props.property.status)?(this.props.property.status=='Out Of Service')?"Not In Service": this.props.property.status : 'No status'}
					</div>
				</ListItem>
			</Link>
		)
	}
}
export default connect(select)(PropertyCard)



// WEBPACK FOOTER //
// ./src/routes/manager/properties/Card.js